(function () {
  var GIFT_VARIANT_IDS = [44144313696346]; // sticker
  var THRESHOLD_CENTS = 5000; // $50, matches the $50+ free shipping tier

  var syncing = false;

  function realSubtotal(cart) {
    return cart.items.reduce(function (sum, item) {
      if (GIFT_VARIANT_IDS.indexOf(item.variant_id) !== -1) return sum;
      if (item.properties && item.properties._gift === 'true') return sum;
      return sum + item.line_price;
    }, 0);
  }

  function giftLineItems(cart) {
    return cart.items.filter(function (item) {
      return GIFT_VARIANT_IDS.indexOf(item.variant_id) !== -1;
    });
  }

  function syncGifts() {
    if (syncing) return;
    syncing = true;

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var stale = cart.items.filter(function (item) {
          return item.properties && item.properties._gift === 'true' &&
            GIFT_VARIANT_IDS.indexOf(item.variant_id) === -1;
        });
        if (stale.length) {
          return Promise.all(stale.map(function (item) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: String(item.key), quantity: 0 }),
            });
          })).then(function () { return true; });
        }
        var subtotal = realSubtotal(cart);
        var gifts = giftLineItems(cart);
        var missing = GIFT_VARIANT_IDS.filter(function (id) {
          return !gifts.some(function (g) { return g.variant_id === id; });
        });

        if (subtotal >= THRESHOLD_CENTS && missing.length) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: missing.map(function (id) {
                return { id: id, quantity: 1, properties: { _gift: 'true' } };
              }),
            }),
          }).then(function () { return true; });
        }

        if (subtotal < THRESHOLD_CENTS && gifts.length) {
          var removals = gifts.map(function (gift) {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: gift.variant_id, quantity: 0 }),
            });
          });
          return Promise.all(removals).then(function () { return true; });
        }

        return false;
      })
      .then(function (changed) {
        if (changed && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wilomina-auto-gift' });
        }
      })
      .catch(function () {
        // never block checkout on a sync failure
      })
      .finally(function () {
        syncing = false;
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncGifts);
  } else {
    syncGifts();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === 'wilomina-auto-gift') return;
      setTimeout(syncGifts, 150);
    });
  }
})();
